import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly LANG_KEY = 'lang';

  constructor(private translate: TranslateService) {
    this.loadInitialLanguage();
  }

  // Get saved language or default to Arabic
  getCurrentLang(): string {
    return localStorage.getItem(this.LANG_KEY) || 'ar';
  }

  // Change language and update direction
  setLanguage(lang: string): void {
    localStorage.setItem(this.LANG_KEY, lang);
    this.translate.use(lang);

    const isRTL = lang === 'ar';
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }

  // Load language on app start
  loadInitialLanguage(): void {
    const savedLang = this.getCurrentLang();
    this.setLanguage(savedLang);
  }

  // Check if current language is RTL
  isLTR(): boolean {
    return this.getCurrentLang() !== 'ar';
  }
}
